<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{ $route.name }}</h3>
          <!-- breadcrumb -->
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">{{$t('dashboard')}}</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item to="/accounting/stock-in/" active>{{
              $route.name
            }}</b-breadcrumb-item>
          </b-breadcrumb>
          <!-- end breadcrumb -->
        </b-col>
        <b-col md="6">
          <!-- <b-button
            variant="primary"
            class="float-right mt-3"
            @click="showModal()"
            v-b-tooltip.hover
            title="Add Settings"
            size="md"
          >
            <font-awesome-icon icon="plus" />
          </b-button> -->
        </b-col>
      </b-row>

      <paginated-table
        ref="dataTable"
        :can-edit="false"
        :can-delete="false"
        :can-approve="false"
        :can-reject="false"
        :can-show="false"
        :can-edit-modal="true"
        :can-paid="false"
        :data-url="apiUrl.attendanceSetting"
        v-on:editData="doEdit"
        :data-key="dataKey"
        :data-columns="columns"
      >
        <!-- v-on:editData="doEdit" -->
      </paginated-table>
    </b-card>
    <b-modal ref="my-modal" centered hide-footer title="Attendance Setting">
      <form v-on:submit.prevent="doSubmit">
        <div>
          <label for="" class="mt-2 labels">{{$t('day')}} *</label>
          <b-form-select required v-model="model.dayName" :options="nameOfDay"></b-form-select>
        </div>
        <div class="mt-2">
          <label for="" class="mt-2 labels">Start Work Time *</label>
          <b-form-timepicker
            id="datepicker-invalid"
            aria-required="true"
            :state="validateStartTime"
            h23
            v-model="model.startWorkTime"
            show-seconds
          ></b-form-timepicker>
        </div>

        <div class="mt-2">
          <label for="" class="mt-2 labels">End Work Time *</label>
          <b-form-timepicker
            aria-required="true"
            h23
            v-model="model.endWorkTime"
            :state="validateEndTime"
            required
            show-seconds
          ></b-form-timepicker>
        </div>
        <div class="mt-2">
          <label for="" class="mt-2 labels">Off Day </label>
          <b-form-checkbox
            name="check-button"
            switch
            size="lg"
            v-model="model.isOffDay"
            title="Active"
          ></b-form-checkbox>
        </div>
        <!-- <b-form-checkbox name="check-button" switch size="lg" v-model="model.isOffDay" title="Active" @change="changeSwitch([row.item.uuid, 'branch', row.item.isActive])"></b-form-checkbox>
       -->
        <b-button class="mt-4" variant="secondary" @click="hideModal"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
        >
        <b-button class="mt-4 float-right" :disabled="disable" variant="primary" type="submit"
          ><font-awesome-icon icon="save"></font-awesome-icon>Save
        </b-button>
      </form>
    </b-modal>
    <edit-attendance-setting
      ref="editAttendanceSetting"
      v-on:getData="getData"
    ></edit-attendance-setting>
  </div>
</template>

<script>
import PaginatedTable from '../../../components/PaginatedTable.vue';
import EditAttendanceSetting from './EditAttendanceSetting.vue';
export default {
  components: { PaginatedTable, EditAttendanceSetting },
  data() {
    return {
      dataKey: 'attendance_settings',
      validateStartTime: false,
      validateEndTime: false,
      apiUrl: {
        attendanceSetting: window.AppConfig.apiUrl + 'attendance-settings',
      },
      model: {
        uuid: null,
        dayName: null,
        startWorkTime: '',
        endWorkTime: '',
        isOffDay: 0,
      },
      nameOfDay: [
        {
          value: null,
          text: 'Please select Day',
        },
        {
          value: 'Monday',
          text: this.$root.$t('Monday'),
        },
        {
          value: 'Tuesday',
          text: this.$root.$t('Tuesday'),
        },
        {
          value: 'Wednesday',
          text: this.$root.$t('Wednesday'),
        },
        {
          value: 'Thursday',
          text: this.$root.$t('Thursday'),
        },
        {
          value: 'Friday',
          text: this.$root.$t('Friday'),
        },
        {
          value: 'Saturday',
          text: this.$root.$t('Saturday'),
        },
        {
          value: 'Sunday',
          text: this.$root.$t('Sunday'),
        },
      ],
      columns: [
        {
          key: 'dayName',
          label: this.$root.$t('Day'),
          },
        {
          key: 'startWorkTime',
          label: this.$root.$t('startWorkTime'),
          class: 'text-center'
        },
        {
          key: 'endWorkTime',
          label: this.$root.$t('endWorkTime'),
          class: 'text-center'
        },
        {
          key: 'isOffDay',
          label: this.$root.$t('offDay'),
          class: 'text-center'
        },
        {
          key: 'actionTypes',
          label: '',
        },
      ],
    };
  },
  computed: {
    disable() {
      if (this.model.startWorkTime === '') {
        return true;
      } else if (this.model.endWorkTime === '') {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    'model.startWorkTime'(value) {
      if (value !== '') this.validateStartTime = true;
    },

    'model.endWorkTime'(value) {
      if (value !== '') this.validateEndTime = true;
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    doSubmit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.model.uuid !== null) {
            this.model.isOffDay === true ? 1 : 0; /** check if isOffDay value equals true(boolean), return value to 1(number) */
            const isOff = this.model.isOffDay;
            this.$http
              .patch(this.apiUrl.attendanceSetting + '/' + this.model.uuid, {
                  dayName: this.model.dayName,
                  startWorkTime: this.model.startWorkTime,
                  endWorkTime: this.model.endWorkTime,
                  isOffDay: isOff
              })
              .then(() => {
                this.hideModal();
                // this.$store.dispatch('notification/success', 'Setting Update Saved');
                // this.$emit('getData');
              })
              .catch((error) => this.$store.dispatch('notification/error', error));
          } else {
            this.model.isOffDay === true ? 1 : 0; /** check if isOffDay value equals true(boolean), return value to 1(number) */
            const isOff = this.model.isOffDay;
            this.$http
              .post(this.apiUrl.attendanceSetting,{
                  dayName: this.model.dayName,
                  startWorkTime: this.model.startWorkTime,
                  endWorkTime: this.model.endWorkTime,
                  isOffDay: isOff
              })
              .then(() => {
                this.hideModal();
                // this.$store.dispatch('notification/success', 'Setting Saved');
                // this.getData();
              })
              .catch((error) => this.$store.dispatch('notification/error', error));
          }
        }
      });
    },

    getData() {
      this.isLoading = true;
      this.$refs.dataTable.getDataTable();
    },

    showModal() {
      this.model.dayName = null;
      this.model.startWorkTime = '';
      this.model.endWorkTime = '';
      this.model.isOffDay = 0;
      this.$validator.reset();
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    doEdit(row) {
      this.$refs.editAttendanceSetting.showModal(row);
    },
    doShowModal(row) {
      this.$refs.editAttendanceSetting.showModal(row);
    },
  },
};
</script>
